import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import { getPaymentModeDets } from "../PaymentModeHed/PaymentModeController"
import DPAlert from "framework/widgets/DPAlert"
import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from 'react-paginate';



const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const PaymentModeDetContent = ({
  DataRow,
  Disable,
  setarRow,
  menuCode,
  currentPage,
  setCurrentPage
}) => {


  const [tabledata, SetTable] = useState([]) // useste for table 
  const [alertShow, setsweetAlertShow] = useState(false)
  const [alertDesc, SetAlertDesc] = useState("")

  //*** useState to save table data */
  const [postsPerPage] = useState(10)
  //*** End of useStates */

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = tabledata.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  useEffect(() => {
    SetTable(DataRow)
  }, [DataRow])

  ///** Functions for Payment Details handle */
  // function handleAddRowNested() {
  //   const modifiedRows = [...DataRow]
  //   modifiedRows.push({
  //     id: modifiedRows.length + 1,
  //     code: "",
  //     desc: "",
  //     format: "",
  //     rate: "",
  //     state: false,
  //     order: "",

  //   })
  //   setarRow(modifiedRows)
  // }


  function handleAddRowNested() {
    const modifiedRows = [...DataRow];

    const hasEmptyRow = modifiedRows.find(x => x.code === "" || x.desc === "");

    if (hasEmptyRow) {
      return false;
    }

    const maxId = Math.max(...modifiedRows.map(row => row.id));

    modifiedRows.push({
      id: maxId + 1,
      code: "",
      desc: "",
      format: "",
      rate: "",
      state: false,
      order: "",
    });

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRow(idModification);
  }



  /**
     * @description This function is used to change the value of particular field in particular row.
     * @param {string} value - value of the row.
     * @param {string} id - id of the row.
     * @param {string} element - element of the row.
  */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
     * @description This function is used to change the value of complete row.
     * @param {JSON} row - row of the table.
     * @param {string} id - id of the row.
  */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    setarRow(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  // function handleRemoveRow(id) {

  //   const modifiedRows = [...DataRow]
  //   const index = modifiedRows.findIndex(obj => obj.id === id)

  //   if (index !== -1) {
  //     modifiedRows.splice(index, 1);

  //     for (let i = 0; i < modifiedRows.length; i++) {
  //       modifiedRows[i].id = i + 1;
  //     }

  //     setarRow(modifiedRows);
  //   }
  // }


  function handleRemoveRow(id) {
    const modifiedRows = [...DataRow];
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    modifiedRows.splice(objectIndex, 1);

    // Reassign unique IDs to the remaining rows
    for (let i = 0; i < modifiedRows.length; i++) {
      modifiedRows[i].id = i + 1;
    }

    if (modifiedRows.length === 0) {
      modifiedRows.push({
        id: modifiedRows.length + 1,
        code: "",
        desc: "",
        format: "",
        rate: "",
        state: false,
        order: "",
      });

    }

    const idModification = modifiedRows.map((item, index) => {
      item.id = index + 1;
      return item
    })

    setarRow(idModification);
  }

  return (
    <React.Fragment>
      <Row>
        <DPAlert
          confirm_both={alertShow}
          title={"Payment Mode Master !"}
          description={alertDesc}
          showCancel={false}
          btnColor={"success"}
          cancelColor={"danger"}
          onConfirm={() => {
            setsweetAlertShow(false)
          }}
          btnYes={"OK"}
        />
      </Row>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"paymodeDet"} >
            <thead className="table-light">
              <tr>
                <th>Code </th>
                <th></th>
                <th>Description </th>
                <th style={{ textAlign: "right" }}>Format</th>
                <th style={{ textAlign: "right" }}>Rate</th>
                <th style={{ textAlign: "center" }}>Is Date Required</th>
                <th style={{ textAlign: "right" }}>Order</th>
              </tr>
            </thead>
            <tbody disabled={true}>

              {currentPosts.map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={handleRemoveRow}
                  Disable={Disable}
                  AlertShow={setsweetAlertShow}
                  AlertDesc={SetAlertDesc}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  menuCode={menuCode}
                />
              ))}
            </tbody>
          </table>
          <Row sm={12} md={12} className="mb-4-sm">
            <Col>
              <Button
                onClick={() => {
                  handleAddRowNested()
                }}
                color="success"
                className="mt-1"
                disabled={Disable}
                size="sm"
              >
                <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
              </Button>
            </Col>
            <Col>
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={Math.ceil(tabledata.length / postsPerPage)}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                forcePage={currentPage - 1}
                renderOnZeroPageCount={null}
                activeClassName={'active'}
                activeLinkClassName={'page-link'}
                containerClassName={'pagination justify-content-end pagination-sm'}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  )
}
export default PaymentModeDetContent

const TableRow = ({ FormRow, Key, RemoveRow, Disable, AlertShow, AlertDesc, changeRowValueChanges, handleObjectChange, menuCode }) => {

  const [state, SetState] = useState(FormRow.code != undefined ? FormRow.datereq == 1 ? true : false : true)
  const [code, setcode] = useState(FormRow.code != undefined ? FormRow.code : "")
  const [desc, setdesc] = useState(FormRow.desc != undefined ? FormRow.desc : "")
  const [format, setformat] = useState(FormRow.format != undefined ? FormRow.format : "")
  const [rate, setrate] = useState(FormRow.rate != undefined ? FormRow.rate : "0.0")
  const [order, setorder] = useState(FormRow.order != undefined ? FormRow.order : "0")
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [DataTables, SetDatatable] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")
  const ApiURL = window.Links.ApiURL

  //** Columns to be populated/Displayed within the Search window */
  // const columns = [
  //   {
  //     dataField: "id",
  //     text: "Id",
  //     sort: true,
  //   },
  //   {
  //     dataField: "code",
  //     text: "Code",
  //     sort: true,
  //   },
  //   {
  //     dataField: "name",
  //     text: "Name",
  //     sort: true,
  //   }
  // ]
  //************************************ */

  // Table Data
  var SearchData = []

  //**Set the Default sort column and Sort order*/
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.PD_CODE, "txtcode" + Key)) {
      //setcode(row.code)
      getData(row.PD_CODE)
    } else {
      AlertShow(true)
      AlertDesc("This Code already used !")
      setcode("")
      //setsweetAlertShow(true)
      return;
    }
    setmodal_xlarge(!modal_xlarge)
  }

  function getData(code) {
    const authToken = localStorage.getItem("authToken")

    if (code != "") {

      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}paymode/details/search/${code}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`
        },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            const newArray = [...responseData.data]
            var currentRow = FormRow
            currentRow.code = code.toUpperCase()
            currentRow.desc = newArray[0].pD_DESC
            currentRow.format = newArray[0].pD_FORMAT
            currentRow.rate = newArray[0].pD_RATE
            currentRow.order = newArray[0].pD_ORDER
            currentRow.payCodeDisable = true;


            handleObjectChange(currentRow, FormRow.id)

          } else {
            AlertShow(true)
            AlertDesc("Invalid Code !")
            FormRow.code = ""
            FormRow.desc = ""
            FormRow.format = ""
            FormRow.rate = "0.0"
            FormRow.order = "0"
            setcode("")
            setdesc("")
            setformat("")
            setrate("")
            setorder("")

          }
        })
    }

  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  async function clickSearch() {
    let data = await getPaymentModeDets();
    let i = 1;
    data.map((r) => {
      SearchData = SearchData.concat(TableDataBuilder(i, r))
      i++
    });
    SetDatatable(SearchData)
    tog_xlarge();
  }

  const TableDataBuilder = (id, Data) => {
    return { "id": id, "code": Data.pD_CODE, "name": Data.pD_DESC }
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id) => {
    var tbl = document.getElementById("paymodeDet");
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length;
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("txtcode" + i)
        if ("txtcode" + i !== id && txtcode.value.toLowerCase() === strCode.toLowerCase()) {
          return false;
        }
      }
    }
    return true
  }

  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "160px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtcode" + Key}
              value={FormRow.code}
              onChange={(e) => {
                changeRowValueChanges(e.target.value, FormRow.id, "code")
              }}
              onBlur={e => {
                if (CodeValidation(e.target.value, "txtcode" + Key)) {
                  getData(e.target.value, FormRow.id, "code")
                } else {
                  AlertShow(true)
                  AlertDesc("This Code already used !")
                  FormRow.code = ""
                  FormRow.desc = ""
                  FormRow.format = ""
                  FormRow.rate = "0.0"
                  FormRow.order = "0"
                  setcode("")
                  setorder("0")
                  setrate("0.0")
                  setformat("")
                  setdesc("")
                }
              }}
              disabled={Disable ? true : FormRow.payCodeDisable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="12">
            <Button
              outline
              color="success"
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
              disabled={Disable ? true : FormRow.payCodeDisable}
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "400px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="50"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              onChange={(e) => {
                var val = Text(e.target, 50, true, true, "upper", true)
                changeRowValueChanges(val, FormRow.id, "desc")
              }}
              disabled={true}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "150px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              maxLength="20"
              id={"txtformat" + Key}
              value={FormRow.format}
              onChange={(e) => {
                var val = Text(e.target, 20, true, true, "any", true)
                changeRowValueChanges(val, FormRow.id, "format")
              }}
              disabled={Disable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px", textAlign: "right" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              defaultValue="0.0"
              textAlign="right"
              id={"txtrate" + Key}
              value={FormRow.rate}
              onChange={(e) => {
                var val = Numeric(e.target, 18, 10, false)
                changeRowValueChanges(val, FormRow.id, "rate")
              }}
              onBlur={e => {
                const val = DecimalValidation(e.target.value)
                changeRowValueChanges(val, FormRow.id, "rate")
              }}
              disabled={Disable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12" style={{ textAlign: "center" }}>
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              onColor="#626ed4"
              height={23}
              handleDiameter={15}
              disabled={Disable}
              onChange={(e) => {
                changeRowValueChanges(e, FormRow.id, "state")
              }}
              checked={FormRow.state}
              id={"swdatereq" + Key}
            />
          </Col>
        </Row>
      </td>
      <td style={{ width: "120px", margin: "auto" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              defaultValue="0"
              textAlign="right"
              id={"txtorder" + Key}
              value={FormRow.order}
              onChange={(e) => {
                var val = Numeric(e.target, 10, 0, false)
                changeRowValueChanges(val, FormRow.id, "order")
              }}
              onBlur={e => {
                if (e.target.value == "") {
                  setorder("0")
                }

                setorder(parseInt(e.target.value, 10))  // remove front 0
              }}
              disabled={Disable}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-0">
          <Col md="1">
            <Button
              outline
              color="danger"
              id={"btnDelete" + Key}
              onClick={e => {
                RemoveRow(FormRow.id)
              }}
              disabled={Disable}
              size="sm">
              <i
                className="mdi mdi-delete"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
          <DPSearchBoxDynamic
            searchData={[]}
            columns={[]}
            defaultSorted={defaultSorted}
            mainTitle={"Payment Mode Detail Search"}
            SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"PAYMODEDET"}
            MenuCode={menuCode}
            KeyVal={"DET"}
            searchBy={"PD_CODE"}
            FilterStr={groupFilter}
          />

        </Row>
      </td>
    </tr>
  )
}